export interface LimitsType {
  average_load: number,
  maximum_load: number,
  minimum_load: number,
  wallet_limit: number,
}

/**
 * @description
 * transformer for limits in wallet api
 * @param limits - limits of wallet transactions
 */
export const limitsTransformer = (limits:LimitsType) => {
  if (!limits) {
    return {};
  }
  return {
    averageLoad: limits.average_load || 1500,
    maximumLoad: limits.maximum_load || 10000,
    minimumLoad: limits.minimum_load || 1000,
    walletLimit: limits.wallet_limit || 10000,
  };
};
